import { take, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ApiConfig } from '~shared/constants/api.config';

import { LoginSsoResponse } from '../models/login-sso-response.interface';
import { ParamMap } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BuyerAccountService {
  constructor(
    private httpClient: HttpClient,
  ) {}

  public loginToSSO(paramMap?: ParamMap): void {
    const params =  paramMap ?
      new HttpParams()
        .set('redirectTo', paramMap.get('redirect_uri'))
        .append('state', paramMap.get('state'))
        .append('nonce', paramMap.get('nonce'))
      : {
        'redirectTo': null,
        'state': null,
        'nonce': null
      };

    this.httpClient.get<LoginSsoResponse>(
      `${ApiConfig.SVC_BUYER_ACCOUNT_API_URL()}/login/sso`,
      { params }
    ).pipe(
      take(1)
    ).subscribe(({ redirectUrl }) =>
      window.location.href = redirectUrl
    );
  }
}
